import React, { useState, useEffect, useRef } from 'react'
import { RenderSubmissionStatus } from '../../utils/CommonGroupingItem';
import { twoDecimalRound } from '../../utils/commonFunction';
import SubmissionAndResultStatus from '../courses/DetailCoursesBlocks/AssessmentBlocks/SubmissionAndResultStatus';
import { useParams } from 'react-router-dom';


function AssessmentDetails({ assessmentHeader,  studentDetails,   isSubmissionAndResult = false }) {
    const { id, tab, type, subId , subType , subtab, subSubId,tabList,tabType} = useParams();
    const [expanded, setExpanded] = useState(false);
    const [showSeeMore, setShowSeeMore] = useState(false);
    const descriptionRef = useRef(null);
    const search = window.location.search;
    const IDs = new URLSearchParams(search)
    const assess_id = IDs.get('assess_id');
    const intake_id = IDs.get('intake_id');
    let assessment_id = IDs.get('assess_id');
    
    useEffect(()=>{
      if (assessment_id?.includes("attempts/list")) {
        assessment_id = assessment_id.split("/")[0]; 
      } else {
        assessment_id = assessment_id;
      }
    },[assessment_id])

    const description = isSubmissionAndResult ? null : assessmentHeader?.details;

    useEffect(() => {
        const checkOverflow = () => {
            if (descriptionRef.current) {
                setShowSeeMore(descriptionRef.current.scrollHeight > descriptionRef.current.clientHeight);
            }
        };

        checkOverflow();
    }, [description]);

    const date = new Date(isSubmissionAndResult == false ? assessmentHeader?.marking_deadline_date * 1000 : assessmentHeader?.open_date_time * 1000);
    const date2 = new Date(assessmentHeader?.close_date_time * 1000);

    const formattedDate = `${String(date.getDate()).padStart(2, '0')} ${date.toLocaleString('default', { month: 'long' })} ${String(date.getFullYear()).slice(-2)} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;

    // attempt date
    const attemptDate = new Date(assessmentHeader?.attempt_time * 1000);
    const formatAttemptDate = `${String(attemptDate.getDate()).padStart(2, '0')} ${attemptDate.toLocaleString('default', { month: 'long' })} ${String(attemptDate.getFullYear()).slice(-2)} ${String(attemptDate.getHours()).padStart(2, '0')}:${String(attemptDate.getMinutes()).padStart(2, '0')}`;
    
    const closeformattedDate = `${String(date2.getDate()).padStart(2, '0')} ${date2.toLocaleString('default', { month: 'long' })} ${String(date2.getFullYear()).slice(-2)} ${String(date2.getHours()).padStart(2, '0')}:${String(date2.getMinutes()).padStart(2, '0')}`;

    /**
     * Indicates whether the assessment uses the "Not Graded" grading type.
     * Grading type value 4 represents assessments that are not graded.
    */
    const isNotGraded = Number(assessmentHeader?.grading_type) === 4;
    
    /**
     * Builds assessment detail cards based on context (submission result vs marking view).
     *
     * @param {boolean} isSubmissionAndResult - Flag to switch between submission/result view and assessment view
     * @param {boolean} isNotGraded - Flag indicating grading is disabled
     * @param {Object} assessmentHeader - Header data containing assessment details
     * @param {string} formattedDate - Formatted marking/open date string
     * @param {string} closeformattedDate - Formatted close date string
     * @param {string} formatAttemptDate - Formatted attempt date string
     * @param {string} tabList - Active tab identifier
     * @param {string} tabType - Active tab type (e.g., open/closed)
     * @returns {Array<Object>} List of assessment detail objects for UI rendering
    */
    const assessmentDetails = isSubmissionAndResult == false
        ? [
            {
                title: "Marking Status",
                value: isNotGraded
                    ? "Not Graded"
                    : assessmentHeader?.mark_status
                        ? assessmentHeader?.mark_status
                        : "-",

                tooltip: assessmentHeader?.mark_status
                        ? assessmentHeader?.mark_status
                        : "-"
            },

            {
                title: "Marking Deadline",
                value: assessmentHeader?.marking_deadline_date
                    ? formattedDate
                    : "-",

                tooltip: assessmentHeader?.marking_deadline_date
                    ? formattedDate
                    : "-"
            },

            {
                title: "Submissions",
                value: assessmentHeader?.submissions
                    ? assessmentHeader?.submissions
                    : "-",

                tooltip: assessmentHeader?.submissions
                    ? assessmentHeader?.submissions
                    : "-"
            },

            {
                title: "Average Mark",
                value: isNotGraded
                    ? "Not Graded"
                    : assessmentHeader?.AvgMarks
                        ? assessmentHeader?.AvgMarks
                        : "-",

                tooltip: assessmentHeader?.AvgMarks
                        ? assessmentHeader?.AvgMarks
                        : "-"
            },

            {
                title: "Submission rate",
                value: assessmentHeader?.submissions_rate
                    ? assessmentHeader?.submissions_rate
                    : "-",

                tooltip: assessmentHeader?.submissions_rate
                    ? assessmentHeader?.submissions_rate
                    : "-"
            }
        ]
        : [
            (tabList == "attempts" && tabType == "open") && {
                title: "Attempt Date",
                value: assessmentHeader?.attempt_time
                    ? formatAttemptDate
                    : "-"
            },

            {
                title: "Open Date & Time",
                value: assessmentHeader?.open_date_time
                    ? formattedDate
                    : "-"
            },

            {
                title: "Close Date & Time",
                value: assessmentHeader?.close_date_time
                    ? closeformattedDate
                    : "-"
            },

            assessmentHeader?.totalHybirdQuestionScore && {
                title: "Hybrid Score",
                value: isNotGraded
                        ? "Not Graded" 
                        :`${(
                            assessmentHeader?.ass_hybrid_marks !== "" &&
                            assessmentHeader?.ass_hybrid_marks !== null &&
                            assessmentHeader?.ass_hybrid_marks !== undefined
                        )
                            ? twoDecimalRound(assessmentHeader?.ass_hybrid_marks)
                            : "?"
                    } /${(
                        assessmentHeader?.totalHybirdQuestionScore !== "" &&
                        assessmentHeader?.totalHybirdQuestionScore !== null &&
                        assessmentHeader?.totalHybirdQuestionScore !== undefined
                    )
                        ? assessmentHeader?.totalHybirdQuestionScore
                        : "?"
                    }`
            },

            {
                title: "Smart Score",
                value: isNotGraded
                    ? "Not Graded" 
                    :`${(
                    assessmentHeader?.ass_smart_marks !== "" &&
                    assessmentHeader?.ass_smart_marks !== null &&
                    assessmentHeader?.ass_smart_marks !== undefined
                )
                    ? twoDecimalRound(assessmentHeader?.ass_smart_marks)
                    : "?"
                    } /${(
                        assessmentHeader?.totalSmartQuestionScore !== "" &&
                        assessmentHeader?.totalSmartQuestionScore !== null &&
                        assessmentHeader?.totalSmartQuestionScore !== undefined
                    )
                        ? assessmentHeader?.totalSmartQuestionScore
                        : "?"
                    }`
            },

            {
                title: "Marking Status",
                value: (
                    <p className='mb-0'>
                        { assessmentHeader?.mark_status
                                ? (
                                    <span
                                        className={
                                            assessmentHeader?.mark_status !== "Marked"
                                                ? "as-green-bg as-widget"
                                                : "as-red-bg as-widget"
                                        }
                                    >
                                        {assessmentHeader?.mark_status}
                                    </span>
                                )
                                : "-"
                        }
                    </p>
                ),

                tooltip: assessmentHeader?.mark_status
            }
        ];
    return (
        <>
            <div className="card-new card card-profile-info-card mb-30 mt-0 padding-20">
                <div className="card-header" title={`${(tabList == "attempts" && tabType == "open") ? "Attempt Details" : "Assessment Details"}`}>
                    {(tabList == "attempts" && tabType == "open") ? (
                        <span>
                        Attempt Details: {studentDetails?.studentName}
                        </span>
                       
                    ) : (
                    <span>
                        Assessment Details{studentDetails?.studentName ? `: ${studentDetails?.studentName}` : ""}
                        </span>
                    )}
  
                </div>
                <div className="card-body-inr card-body-info" style={{ paddingTop: 10 }}>
                    <div className="basic-info-box">
                        <div className='d-flex flex-wrap justify-content-between align-items-center'>
                            {isSubmissionAndResult == false ? assessmentDetails?.map((detail, index) => {
                                return (
                                    <div className="assessment-details-box" key={index}>
                                        <h6 title={detail?.title}>{detail?.title}&nbsp;:</h6>
                                        <p title={detail?.tooltip}>&nbsp;{detail?.value}</p>
                                    </div>
                                )
                            }) : assessmentDetails?.map((detail, index) => {
                                if (!detail?.value) {
                                    return null;
                                }
                                return (
                                    <div className={`assessment-details-box d-flex flex-column`} key={index}>
                                        <h6 title={detail?.title}>{detail?.title}&nbsp;:</h6>
                                        <p title={detail?.tooltip ? detail?.tooltip : detail?.value}>{detail?.value}</p>
                                    </div>
                                )
                            })}
                            {isSubmissionAndResult && tabList !== "attempts" && tabType !== "open" && assessmentHeader && assessmentHeader?.submission_id ? <div className="col-md-6 col-lg-4">
                                <SubmissionAndResultStatus submission_id={assessmentHeader?.submission_id} assessmentHeader={assessmentHeader}/>
                            </div> : null}
                        </div>
                    </div>
                </div>

                {description ? <div className="mt-2 description-title" title="Detailed Instructions">Detailed Instructions:</div> : null}

                {description ? <div className={`description-container fontsize-16`}>
                    <p
                        ref={descriptionRef}
                        style={{ paddingTop: 10 }}
                        className={`description-p ${expanded ? 'expanded' : 'collapsed'}`}
                        dangerouslySetInnerHTML={{ __html: description }}
                    />

                    {showSeeMore && (
                        <div onClick={() => setExpanded(!expanded)} className="toggle-button">
                            {expanded ? (
                                <>
                                    See Less <i className="fas fa-minus-circle"></i>
                                </>
                            ) : (
                                <>
                                    See More <i className="fas fa-plus-circle"></i>
                                </>
                            )}
                        </div>
                    )}
                </div> : null}
            </div>
        </>
    )
}

export default AssessmentDetails